@if (showBookingForm) {
<div class="container py-4">
  <div class="my-5 text-center">
    <img class="d-block mx-auto mb-5" src="{{bookingConfigType.headerConfig.logoUrl}}"
      alt="{{bookingConfigType.headerConfig.logoAlt}}" class="logo-width-25">
    <h2>
      @if (translate.getActiveLang() === 'sv') {
      <span>{{ bookingConfigType.headerConfig.header1SV }}</span>
      }
      @if (translate.getActiveLang() === 'en') {
      <span>{{ bookingConfigType.headerConfig.header1EN }}</span>
      }
    </h2>
    <p class="lead">
      @if (translate.getActiveLang() === 'sv') {
      <span>{{ bookingConfigType.headerConfig.header2SV }}</span>
      }
      @if (translate.getActiveLang() === 'en') {
      <span>{{ bookingConfigType.headerConfig.header2EN }}</span>
      }
    </p>
  </div>
  <!-- Flight icon and method of booking selection -->
  <div class="my-5 text-center">
    <table>
      <tr>
        @if (hasShuttleDepartureConfig();) {
        <td>
          <button class="fab-button-50" mat-fab color="primary" aria-label="Boka utresa"
            (click)="showDepartureClick();">
            <mat-icon class="icon-scale-2">flight_takeoff</mat-icon>
          </button>
          <br><br>
          <mat-checkbox [checked]="showDeparture" (change)="showDepartureChange($event)">
            @if (translate.getActiveLang() === 'sv') {
            <span>{{ bookingConfigShuttleDeparture?.shuttleTypeCheckboxSV
              }}</span>
            }
            @if (translate.getActiveLang() === 'en') {
            <span>{{ bookingConfigShuttleDeparture?.shuttleTypeCheckboxEN
              }}</span>
            }
          </mat-checkbox>
          @if (translate.getActiveLang() === 'sv') {
          <p><small>{{
              bookingConfigShuttleDeparture?.shuttleTypeDescriptionSV
              }}</small></p>
          }
          @if (translate.getActiveLang() === 'en') {
          <p><small>{{
              bookingConfigShuttleDeparture?.shuttleTypeDescriptionEN
              }}</small></p>
          }
        </td>
        }
        @if (hasShuttleArrivalConfig();) {
        <td>
          <button class="fab-button-50" mat-fab color="primary" aria-label="Boka inresa"
            (click)="showArrivalClick();">
            <mat-icon class="icon-scale-2">flight_land</mat-icon>
          </button>
          <br><br>
          <mat-checkbox [checked]="showArrival" (change)="showArrivalChange($event)">
            @if (translate.getActiveLang() === 'sv') {
            <span>{{ bookingConfigShuttleArrival?.shuttleTypeCheckboxSV
              }}</span>
            }
            @if (translate.getActiveLang() === 'en') {
            <span>{{ bookingConfigShuttleArrival?.shuttleTypeCheckboxEN
              }}</span>
            }
          </mat-checkbox>
          @if (translate.getActiveLang() === 'sv') {
          <p><small>{{ bookingConfigShuttleArrival?.shuttleTypeDescriptionSV
              }}</small></p>
          }
          @if (translate.getActiveLang() === 'en') {
          <p><small>{{ bookingConfigShuttleArrival?.shuttleTypeDescriptionEN
              }}</small></p>
          }
        </td>
        }
      </tr>
    </table>
  </div>
  <div [hidden]="!showArrival && !showDeparture">
    <form [formGroup]="bookingForm">
      <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
        <mat-icon class="mr-3">person</mat-icon>{{ 'FORM.PERSONAL_DETAILS' | transloco }}
      </mat-toolbar>
      <app-text-input [formControl]='bookingForm.controls["firstname"]' [label]="'FORM.FIRST_NAME' | transloco"
        [placeholder]="'PLACEHOLDER.FIRST_NAME' | transloco" [icon]="'account_box'">
      </app-text-input>
      <app-text-input [formControl]='bookingForm.controls["lastname"]' [label]="'FORM.LAST_NAME' | transloco"
        [placeholder]="'PLACEHOLDER.LAST_NAME' | transloco" [icon]="'account_box'">
      </app-text-input>
      <app-text-input [formControl]='bookingForm.controls["email"]' [type]="'email'" [label]="'Email'"
        [placeholder]="'PLACEHOLDER.EMAIL' | transloco" [icon]="'email'">
      </app-text-input>
      <app-text-input [formControl]='bookingForm.controls["cellular"]' [type]="'tel'"
        [label]="'FORM.PHONENUMBER' | transloco" [placeholder]="'PLACEHOLDER.PHONENUMBER' | transloco"
        [icon]="'smartphone'">
      </app-text-input>
      @if (isBookingNrRequired) {
      <div>
        <app-text-input [formControl]='bookingForm.controls["bookingnr"]' [label]="'FORM.BOOKINGNUMBER' | transloco"
          [placeholder]="'FORM.BOOKINGNUMBER' | transloco" [icon]="'account_box'" [uppercase]="true">
        </app-text-input>
      </div>
      }
      @if (isCarIdRequired) {
      <div>
        <app-text-input [formControl]='bookingForm.controls["carid"]' [label]="'FORM.CARID' | transloco"
          [placeholder]="'FORM.CARID' | transloco" [icon]="'directions_car'" [uppercase]="true" [minlength]="4"
          [maxlength]="9">
        </app-text-input>
      </div>
      }
      @if (isBusOverbooked) {
      <mat-toolbar color="accent" class="mb-4 mat-elevation-z8 animate__animated animate__bounce">
        Antal personer får inte plats på vald transfer
      </mat-toolbar>
      }
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.PERSONS' | transloco }}</mat-label>
        <mat-select formControlName="persons" (selectionChange)="checkPersonsOnRoutes()">
          @for (item of persons; track item) {
          <mat-option [value]="item.value">
            {{item.viewValue}}
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>person</mat-icon>
        @if (!bookingForm.controls.persons.valid && bookingForm.controls.persons.touched) {
        <mat-error>
          {{'ERROR.PERSONS' | transloco }}
        </mat-error>
        }
      </mat-form-field>
      @if (showHandbaggage) {
      <mat-checkbox formControlName="onlyHandBaggage" (change)="checkBaggage($event)"> <span
          class="font-weight-light">{{
          'FORM.ONLY_HANDBAGGAGE' | transloco }}
        </span>
      </mat-checkbox>
      }
      <app-textarea-input [formControl]='bookingForm.controls["comment"]' [label]="'FORM.COMMENT' | transloco"
        [placeholder]="'PLACEHOLDER.OPTIONAL_INFO' | transloco">
      </app-textarea-input>
      <fieldset [disabled]="!bookingForm.controls.persons.valid">
        <div [hidden]="!showDeparture">
          <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
            <mat-icon class="mr-3">flight_takeoff</mat-icon>{{ 'PLACEHOLDER.DEPARTURE' | transloco }}
          </mat-toolbar>
          @if (bookingConfigShuttleDeparture?.type == 'DEPARTUREFLIGHT' ) {
          <div>
            <app-booking-select-departure #selectDepartureChild [parking]="false"
              (newItemEvent)="setDepartureFlight($event)"></app-booking-select-departure>
          </div>
          }
          @if (bookingConfigShuttleDeparture?.type == 'DEPARTUREFLIGHTANDTIME' ) {
          <div>
            <app-booking-select-departure #selectDepartureChild [parking]="false"
              (newItemEvent)="setDepartureFlight($event)"></app-booking-select-departure>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'FORM.ARRIVAL_TIME' | transloco }}</mat-label>
              <mat-select (selectionChange)="getShuttleTimeBeforeFlight($event)" formControlName="shuttleDepartureTime"
                [disabled]="departureTravelTime==null">
                <mat-option [value]="this.arriveAtParking180Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.3_HOURS_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking180Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking165Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.2.75_HOURS_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking165Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking150Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.2.5_HOURS_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking150Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking135Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.2.25_HOURS_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking135Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking120Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.2_HOURS_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking120Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking105Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.1.75_HOUR_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking105Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking90Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.1.5_HOUR_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking90Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking75Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.1.25_HOUR_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking75Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
                <mat-option [value]="this.arriveAtParking60Min">
                  <div class="display-flex">
                    <span class="mr-2">
                      {{ 'PLACEHOLDER.1_HOUR_BEFORE' | transloco }}
                    </span>
                    <div class="spacer"></div>
                    <span class="font-weight-light">Kl:
                      {{this.arriveAtParking60Min | date: 'HH:mm'}}
                    </span>
                  </div>
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>schedule</mat-icon>
              @if (!bookingForm.controls.shuttleDepartureTime.valid && bookingForm.shuttleDepartureTime.touched) {
              <mat-error>
                {{ 'ERROR.SELECT_PARKING_FROM' | transloco }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          }
          @if (bookingConfigShuttleDeparture?.type == 'DEPARTURETIMETABLE' ) {
          <div>
            <mat-form-field appearance="outline" (click)="picker3.open()">
              <mat-label>{{'FORM.DEPARTURE_DATE' | transloco }}</mat-label>
              <input matInput [min]="minDate" [matDatepicker]="picker3" formControlName="flightDepartureDate"
                (dateChange)="dateChangedDeparture($event)">
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker touchUi #picker3></mat-datepicker>
              @if (!bookingForm.controls.flightDepartureDate.valid && bookingForm.controls.flightDepartureDate.touched)
              {
              <mat-error>
                {{'ERROR.DATE' | transloco }}
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'FORM.PICKUPTIME' | transloco }}</mat-label>
              <mat-select formControlName="routeDeparture" (selectionChange)="checkPersonsOnRoutes()">
                @for (route of plannedShuttleBussesDeparture; track route) {
                <mat-option [value]="route">
                  <div class="display-flex">
                    <span>
                      Kl: {{formatShuttleTime(route.startDate)}}
                    </span>
                    <div class="mr-1"></div>
                    @if (route.seats != null) {
                    <span>{{ ('QUALITY_HOTEL.AVAILABLE_SPOTS' | transloco) }}
                      ({{(route.seats - route.passengers)}})</span>
                    }
                  </div>
                </mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>schedule</mat-icon>
              @if (!bookingForm.controls.routeDeparture.valid && bookingForm.controls.routeDeparture.touched) {
              <mat-error>
                {{ 'ERROR.TIME' | transloco }}
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{'FORM.TERMINAL' | transloco }}</mat-label>
              <mat-select formControlName="terminalDeparture">
                @for (terminal of departureTerminals; track terminal) {
                <mat-option [value]="terminal.terminalCode">
                  {{terminal.terminalName}}
                </mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>place</mat-icon>
              @if (!bookingForm.controls.terminalDeparture.valid && bookingForm.controls.terminalDeparture.touched) {
              <mat-error>
                {{'ERROR.TERMINAL' | transloco }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          }
        </div>
        <div [hidden]="!showArrival">
          <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
            <mat-icon class="mr-3">flight_land</mat-icon>{{ 'PLACEHOLDER.ARRIVAL' | transloco }}
          </mat-toolbar>
          <!-- Arrival Mode Toggle (for hotel bookings with arrival) -->
          <div class="my-4">
            <div class="p-3 info-box-border">
              <div class="info-label-ml-mb">
                <div>{{ 'QUALITY_HOTEL.BOOK_WITH' | transloco }}</div>
                <div class="d-flex align-items-start mt-1">
                  <mat-icon class="d-flex align-items-center"
                    class="info-icon-small">info</mat-icon>
                  <small class="info-text-small">{{ 'QUALITY_HOTEL.INFO_TEXT' | transloco
                    }}</small>
                </div>
              </div>
              <mat-radio-group [value]="useFlightForArrival"
                (change)="useFlightForArrival = $event.value; onArrivalModeToggle()" color="accent">
                <mat-radio-button [value]="false" class="mr-4">{{ 'QUALITY_HOTEL.BY_TIME' | transloco
                  }}</mat-radio-button>
                <mat-radio-button [value]="true">{{ 'QUALITY_HOTEL.BY_FLIGHT' | transloco }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          @if (bookingConfigShuttleArrival?.type == 'ARRIVALFLIGHT' || bookingConfigShuttleArrival?.type ==
          'ARRIVALFLIGHTANDTIMETABLE') {
          <div>
            <app-booking-select-arrival #selectArrivalChild [needStartDate]="false" [limitShuttles]="false"
              [timeZone]="getOrgTimeZone()" (newItemEvent)="setArrivalFlight($event)"></app-booking-select-arrival>
          </div>
          }
          @if (bookingConfigShuttleArrival?.type == 'ARRIVALTIMETABLE' || bookingConfigShuttleArrival?.type ==
          'ARRIVALFLIGHTANDTIMETABLE') {
          <div>
            @if (bookingConfigShuttleArrival?.type == 'ARRIVALTIMETABLE' ) {
            <mat-form-field appearance="outline" (click)="picker3.open()">
              <mat-label>{{'FORM.ARRIVAL_DATE' | transloco }}</mat-label>
              <input matInput [min]="minDate" [matDatepicker]="picker3" formControlName="flightArrivalDate"
                (dateChange)="dateChangedArrival($event)">
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker touchUi #picker3></mat-datepicker>
              @if (!bookingForm.controls.flightArrivalDate.valid && bookingForm.controls.flightArrivalDate.touched) {
              <mat-error>
                {{'ERROR.DATE' | transloco }}
              </mat-error>
              }
            </mat-form-field>
            }
            <mat-form-field appearance="outline">
              <mat-label>{{ 'FORM.PICKUPTIME' | transloco }}</mat-label>
              <mat-select formControlName="routeArrival"
                (selectionChange)="checkPersonsOnRoutes(); clearArrivalBookingError()">
                @for (route of plannedShuttleBussesArrival; track route) {
                <mat-option [value]="route">
                  <div class="display-flex">
                    <span>
                      Kl: {{formatShuttleTime(route.startDate)}}
                    </span>
                    <div class="mr-1"></div>
                    @if (route.seats != null) {
                    <span>{{ ('QUALITY_HOTEL.AVAILABLE_SPOTS' | transloco) }}
                      ({{(route.seats - route.passengers)}})</span>
                    }
                  </div>
                </mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>schedule</mat-icon>
              @if (!bookingForm.controls.routeArrival.valid && bookingForm.controls.routeArrival.touched) {
              <mat-error>
                {{ 'ERROR.TIME' | transloco }}
              </mat-error>
              }
            </mat-form-field>
            @if (bookingConfigShuttleArrival?.type == 'ARRIVALTIMETABLE') {
            <mat-form-field appearance="outline">
              <mat-label>{{'FORM.TERMINAL' | transloco }}</mat-label>
              <mat-select formControlName="terminalArrival">
                @for (terminal of arrivalTerminals; track terminal) {
                <mat-option [value]="terminal.terminalCode">
                  {{terminal.terminalName}}
                </mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>place</mat-icon>
              @if (!bookingForm.controls.terminalArrival.valid && bookingForm.controls.terminalArrival.touched) {
              <mat-error>
                {{'ERROR.TERMINAL' | transloco }}
              </mat-error>
              }
            </mat-form-field>
            }
          </div>
          }
        </div>
        @if (arrivalBookingError) {
        <div class="Frame805 self-stretch flex-col justify-start items-start gap-4 flex mb-4">
          <div class="rounded-2xl flex-col justify-start items-start flex"
            class="error-box-full">
            <div class="flex justify-between items-center w-full">
              <div class="flex flex-col">
                <p class="error-text">{{ arrivalBookingError }}</p>
              </div>
            </div>
          </div>
        </div>
        }
      </fieldset>
      <mat-checkbox formControlName="consent" class="font-weight-light font-size-1rem-important">{{
        'FORM.TERMS' |
        transloco}}</mat-checkbox>
    </form>
    <p class="consent font-weight-light" (click)="openConsent()" class="consent-text-small">{{
      'FORM.READTERMS' | transloco }}</p>
    <div class="flex-space-between-center">
      <button mat-raised-button color="warn" type="button" (click)="resetForm()">{{ 'FORM.CLEAR' | transloco |
        uppercase}}
      </button>
      <button mat-raised-button type="button" [ngClass]="{ 'success-button': bookingForm.valid && !disableBookingForm() && !isLoading,
                     'grey-button': bookingForm.invalid || disableBookingForm() || isLoading }"
        class="width-fit-content" (click)="openBottomSheet()"
        [disabled]="bookingForm.status === 'INVALID' || disableBookingForm() || isLoading">
        @if (isLoading) {
        <mat-icon>
          <mat-spinner color="accent" diameter="20">
          </mat-spinner>
        </mat-icon>
        }{{ 'FORM.CONTINUE' | transloco | uppercase}}
      </button>
    </div>
  </div>
</div>
}

@if (showQualityDisabled) {
<div class="container py-4">
  <div class="my-5 text-center">
    <img class="d-block mx-auto mb-5" src="{{bookingConfigType.headerConfig.logoUrl}}"
      alt="{{bookingConfigType.headerConfig.logoAlt}}" height="72">
    <p class="lead">
      <span>Kära gäst, <br>
        Från och med 1 augusti använder Quality Hotel inte längre denna tjänst.
      </span>
    </p>
  </div>
</div>
}

@if (showArlandaXPOAppartmentsDisabled) {
<div class="container py-4">
  <div class="my-5 text-center">
    <img class="d-block mx-auto mb-5" src="{{bookingConfigType.headerConfig.logoUrl}}"
      alt="{{bookingConfigType.headerConfig.logoAlt}}" height="72">
    <p class="lead">
      <span>Kära gäst, <br>
        Från och med 30 April 2024 använder Arlanda XPO Appartments inte längre denna tjänst. Kontakta Arlanda XPO
        Appartments för mer information på telefonnummer 08-128 88880.
      </span>
    </p>
  </div>
</div>
}